import React, { useContext, useEffect, useState } from "react";
import classes from "./Navbar.module.css";
import facebook from "../../../assets/socials/facebook.png";
import instagram from "../../../assets/socials/instagram.png";
import linkedin from "../../../assets/socials/linkedin.png";
import twitter from "../../../assets/socials/twitter.png";
import logo from "../../../assets/ALBOURAQ LOGO.png";
import compareicon from "../../../assets/compare icon.svg";
import usericon from "../../../assets/usericon.svg";
import usericon1 from "../../../assets/usericon1.svg";
import PersonIcon from "@mui/icons-material/Person";
import favicon from "../../../assets/favoriteicon.svg";
import MenuIcon from "@mui/icons-material/Menu";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdFavoriteBorder } from "react-icons/md";
import { IoGitCompare } from "react-icons/io5";

import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchBox from "./Search box/SearchBox";
import LanCurrSelect from "./Language and Currency/LanCurrSelect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as LinkSS } from "react-scroll";
import * as Scroll from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../redux/productSlice";
import axios from "axios";
import data from "../../Data.json";
import AuthContext from "../authContext";

const Navbar = ({ toggle, carttoggle }) => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const productData = useSelector((state) => state.products.productData);
  const favoriteData = useSelector((state) => state.products.favorites);
  const compareData = useSelector((state) => state.products.compare);
  const userInfo = useSelector((state) => state.products.userInfo);
  const settings = ["Profile", "Logout"];
  const dispatch = useDispatch();
  const [isScrolled, setIsScrolled] = useState(false);
  const [popover, setPopover] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const location = path.split("/")[1];
  const scroller = Scroll.scroller;

  const NavigateAndScroll = async (props) => {
    await navigate("/");
    scroller.scrollTo(props, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: 50,
    });
  };

  const logout = async () => {
    try {
      // Get the token from local storage
      const token = sessionStorage.getItem("token");

      // If token is not available, there's no need to logout
      if (!token) {
        return;
      }

      // Set up headers with the token
      const headers = {
        Accept: `application/json`,
        Authorization: `Bearer ${token}`,
      };

      // Send a POST request to the logout endpoint
      await axios.get(`${process.env.REACT_APP_TESTING_API}/logout`, {
        headers,
      });

      // Remove the token from local storage after successful logout
      localStorage.removeItem("token");

      dispatch(removeUser());
      navigate(`/login`);
      // Add any additional logic you may need, such as redirecting the user to the login page or updating the application state
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle any errors that occur during logout
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      // Perform any additional actions after successful logout
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle logout error
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY > 80;
      if (isTop !== isScrolled) {
        setIsScrolled(isTop);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <div className={classes.headnav}>
        <div className={classes.header}>
          <div className={classes.logocontainer}>
            <Link to="/">
              <img src={authCtx.companySettings.dark_icon} alt="logodark" />
            </Link>
          </div>
          <div className={classes.headercontent}>
            <div className={classes.topdiv}>
              <p style={{ margin: "auto 0" ,cursor:"pointer"}} 
    onClick={() =>
      window.location.href = `mailto:${authCtx.companySettings.email}`
    } className={classes.emaillink}>
                <span
                  style={{ marginRight: "2px", color: "var(--primary-color)" }}
                >
                  <EmailOutlinedIcon />
                </span>
                {authCtx.companySettings.email}
              </p>
              <p style={{ margin: "auto 0" }}>
                <span
                  style={{ marginRight: "2px", color: "var(--primary-color)" }}
                >
                  <LocalPhoneOutlinedIcon />
                </span>
                {authCtx.companySettings.phone}
              </p>
              <div className={classes.btns}>
                <LanCurrSelect />
                <button
                  className={classes.btn}
                  onClick={() => navigate(`/about-us`)}
                >
                  {language === "eng" ? "ABOUT US" : "A PROPOS"}
                </button>
                <button
                  className={classes.btn}
                  onClick={() => navigate("/events")}
                >
                  {language === "eng" ? "EVENTS" : "ÉVÉNEMENTS"}
                </button>
              </div>
            </div>
            <Divider />
            <div className={classes.bottomdiv}>
              <SearchBox />
              <div className={classes.options}>
                <div
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  className={classes.icon}
                >
                  <Tooltip title={language === "eng" ? "Wishlist" : "Liste De Souhaits"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                        if (userInfo) {
                          navigate(`/wishlist`);
                        } else {
                          navigate(`/login`);
                        }
                      }}
                    >
                      <MdFavoriteBorder
                        alt=""
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {favoriteData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--secondary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {favoriteData?.length}
                    </span>
                  )}
                </div>
                {authCtx?.isCompareEnabled && <div
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  className={classes.icon}
                >
                  <Tooltip title={language === "eng" ? "Compare" : "Comparer"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                        if (userInfo) {
                          navigate(`/compare`);
                        } else {
                          navigate(`/login`);
                        }
                      }}
                    >
                      <IoGitCompare
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {compareData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--secondary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {compareData?.length}
                    </span>
                  )}
                </div>}
                <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                  <Tooltip title={language === "eng" ? "Cart" : "Panier"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                          carttoggle();
                      }}
                    >
                      <ShoppingCartOutlinedIcon
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {productData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--secondary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {productData?.length}
                    </span>
                  )}
                </div>
                <div
                  style={{ width: "30px", height: "30px", marginTop: "-12px" }}
                >
                  <Box sx={{ flexGrow: 0 }}>
                    <Tooltip
                      title={language === "eng" ? "Profile" : "Mon Compte"}
                    >
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        {userInfo?.id ? (
                          <Avatar
                            alt={userInfo.first_name}
                            src={`${process.env.REACT_APP_TESTING_API_IMAGE}/img/${userInfo.image}`}
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                            }}
                            className={classes.icon}
                          />
                        ) : (
                          <PersonIcon
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                            }}
                            className={classes.icon}
                          />
                        )}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div
          className={`${isScrolled ? classes.fixednav_con : classes.navbar}`}
        >
          <div className={classes.navbarscrolled}>
            {isScrolled ? (
              <div className={classes.nav}>
                <div className={classes.logo}>
                  <Link to="/">
                    <img
                      style={{
                        objectFit: "contain",
                        margin: "0 auto",
                        width: "50%",
                      }}
                      src={authCtx.companySettings.dark_icon}
                      alt="logodark"
                    />
                  </Link>
                </div>
                <SearchBox />
                <div className={classes.navlinks_before}>
                  <Link to="/">
                    <p>{language === "eng" ? "HOME" : "ACCUEIL"}</p>
                  </Link>

                  <Link to="/books">
                    <p>{language === "eng" ? "BOOKS" : "LIVRES"}</p>
                  </Link>
                  <Link to="/contactus">
                    <p>CONTACT</p>
                  </Link>
                </div>
              </div>
            ) : (
              <div className={classes.nav}>
                <div className={classes.navlinks}>
                  <Link to="/">
                    <p>{language === "eng" ? "HOME" : "ACCUEIL"}</p>
                  </Link>

                  <Link to="/books">
                    <p>{language === "eng" ? "BOOKS" : "LIVRES"}</p>
                  </Link>
                  <Link to="/collaborators">
                    <p>
                      {language === "eng" ? "Collaborators" : "Collaborateurs"}
                    </p>
                  </Link>

                  <Link to="/collections">
                    <p>{language === "eng" ? "Collections" : "Collections"}</p>
                  </Link>

                  <Link to="/contactus">
                    <p>CONTACT</p>
                  </Link>
                  
                  <Link to="/legal-information">
                    <p>{language === "eng" ? "Legal information" : "Mentions légales"}</p>
                  </Link>
                  {location === "/" ? (
                    <LinkSS to="new_products" smooth={true} duration={500}>
                      <p style={{ textTransform: "uppercase" }}>
                        {language === "eng" ? "NEW PRODUCTS " : "nouveautés"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p
                      style={{ textTransform: "uppercase" }}
                      onClick={() => NavigateAndScroll("new_products")}
                    >
                      {language === "eng" ? "NEW PRODUCTS " : "nouveautés"}
                    </p>
                  )}

                  {location === "/" ? (
                    <LinkSS to="Best_sales" smooth={true} duration={500}>
                      <p style={{ textTransform: "uppercase" }}>
                        {language === "eng"
                          ? "Best sales"
                          : "Meilleures ventes"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p
                      style={{ textTransform: "uppercase" }}
                      onClick={() => NavigateAndScroll("Best_sales")}
                    >
                      {language === "eng" ? "Best sales" : "Meilleures ventes"}
                    </p>
                  )}

                  {location === "/" ? (
                    <LinkSS to="favorites" smooth={true} duration={500}>
                      <p style={{ textTransform: "uppercase" }}>
                        {language === "eng" ? "favorites" : "coups de cœur"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p
                      style={{ textTransform: "uppercase" }}
                      onClick={() => NavigateAndScroll("favorites")}
                    >
                      {language === "eng" ? "favorites" : "coups de cœur"}
                    </p>
                  )}

                  {location === "/" ? (
                    <LinkSS to="newsletter" smooth={true} duration={500}>
                      <p style={{ textTransform: "uppercase" }}>
                        {language === "eng" ? "Newsletter" : "Newsletter"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p
                      style={{ textTransform: "uppercase" }}
                      onClick={() => NavigateAndScroll("newsletter")}
                    >
                      {language === "eng" ? "Newsletter" : "Newsletter"}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <Divider />
        <div className={`${isScrolled ? classes.rightsidenav : classes.none}`}>
          <div className={classes.siderowright}>
            <div
              style={{
                width: "30px",
                height: "30px",
                margin: "8px",
                borderRadius: "50%",
              }}
            >
              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title={language === "eng" ? "Profile" : "Mon Compte"}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    {userInfo?.id ? (
                      <Avatar
                        alt={userInfo.first_name}
                        src={`${process.env.REACT_APP_TESTING_API_IMAGE}/img/${userInfo.image}`}
                        style={{
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                        }}
                        className={classes.icon}
                      />
                    ) : (
                      <PersonIcon
                        style={{
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                          color: "#fff",
                        }}
                      />
                    )}
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {userInfo?.id ? (
                    <div>
                      <MenuItem
                        key={1}
                        onClick={() => {
                          navigate(`/accountprofile`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Profile" : "Mon Compte"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={2}
                        onClick={() => {
                          navigate(`/ordertracking`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng"
                            ? "Orders Tracking"
                            : "Suivi des Commandes"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={3}
                        onClick={() => {
                          navigate(`/refund_return`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng"
                            ? "Orders Returns"
                            : "Retours de Commandes"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={4}
                        onClick={() => (handleCloseUserMenu(), handleLogout())}
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Logout" : "Déconnexion"}{" "}
                        </Typography>
                      </MenuItem>
                    </div>
                  ) : (
                    <div>
                    <MenuItem
                      key={3}
                      onClick={() =>
                        handleCloseUserMenu() & navigate(`/track-order`)
                      }
                    >
                      <Typography textAlign="center">
                      {language === "eng" ? "Track Order" : "Suivre la commande"}
                      </Typography>
                    </MenuItem>
                      <MenuItem
                        key={1}
                        onClick={() =>
                          handleCloseUserMenu() & navigate(`/login`)
                        }
                      >
                        <Typography textAlign="center">
                        {language === "eng" ? "Login" : "Se Connecter"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={2}
                        onClick={() =>
                          handleCloseUserMenu() & navigate(`/register`)
                        }
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Register" : "Créez un compte"}
                        </Typography>
                      </MenuItem>
                    </div>
                  )}
                </Menu>
              </Box>
            </div>
          </div>
          <div className={classes.siderowright}>
            <Tooltip title={language === "eng" ? "Cart" : "Panier"}>
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                    carttoggle();
                }}
              >
                <ShoppingCartOutlinedIcon
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {productData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {productData?.length}
              </span>
            )}
          </div>
          <div className={classes.siderowright}>
            <Tooltip title={language === "eng" ? "Wishlist" : "Liste De Souhaits"}>
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  if (userInfo) {
                    navigate(`/wishlist`);
                  } else {
                    navigate(`/login`);
                  }
                }}
              >
                <MdFavoriteBorder
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {favoriteData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {favoriteData?.length}
              </span>
            )}
          </div>
          {authCtx?.isCompareEnabled && <div className={classes.siderowright}>
            <Tooltip title={language === "eng" ? "Compare" : "Comparer"}>
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  if (userInfo) {
                    navigate(`/compare`);
                  } else {
                    navigate(`/login`);
                  }
                }}
              >
                <IoGitCompare
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {compareData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {compareData?.length}
              </span>
            )}
          </div>}
        </div>
        <div className={`${isScrolled ? classes.leftsidenav : classes.none}`}>
          {authCtx?.companySettings?.facebook && <div className={classes.siderow}>
            <a href={authCtx.companySettings.facebook} target="_blank">
              <FaFacebookF
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>}
          {authCtx?.companySettings?.youtube && <div className={classes.siderow}>
            <a href={authCtx.companySettings.youtube} target="_blank">
              <FaYoutube
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>}
          {authCtx?.companySettings?.twitter && <div className={classes.siderow}>
            <a href={authCtx.companySettings.twitter} target="_blank">
              {" "}
              <FaXTwitter
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>}
          {authCtx?.companySettings?.linkedin &&<div className={classes.siderow}>
            <a href={authCtx.companySettings.linkedin} target="_blank">
              <FaLinkedinIn
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>}
        { authCtx?.companySettings?.insta && <div className={classes.siderow}>
            <a href={authCtx.companySettings.insta} target="_blank">
              {" "}
              <FaInstagram
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>}
        </div>
      </div>
      <div className={classes.mobilenav}>
        <div className={classes.logomobile} onClick={() => navigate("/")}>
          <img
            style={{ objectFit: "contain", margin: "0em auto" }}
            src={authCtx.companySettings.dark_icon}
            alt="logodark"
          />
        </div>
        <div
          style={{
            margin: "auto 0",
            width: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingRight: "0.5em",
          }}
        >
          <button
            style={{
              width: "fit-content",
              justifyContent: "start",
              background: "#4A4A4A",
              padding: ".1em 1.5em .1em 1.5em",
              borderRadius: "0 4em 0 0",
              color: "#fff",
            }}
            onClick={toggle}
          >
            <MenuIcon />
          </button>
          <div className={classes.rightsidenavMobile}>
            <div className={classes.siderowrightmobile}>
              <Tooltip title={language === "eng" ? "Wishlist" : "Liste De Souhaits"}>
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => {
                    if (userInfo) {
                      navigate(`/wishlist`);
                    } else {
                      navigate(`/login`);
                    }
                  }}
                >
                  <MdFavoriteBorder
                    style={{
                      width: "27px",
                      height: "27px",
                      color: "var(--primary-color)",
                      margin: "50% auto",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {favoriteData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {favoriteData?.length}
                </span>
              )}
            </div>
            {authCtx?.isCompareEnabled && <div className={classes.siderowrightmobile}>
              <Tooltip title={language === "eng" ? "Compare" : "Comparer"}>
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => {
                    if (userInfo) {
                      navigate(`/compare`);
                    } else {
                      navigate(`/login`);
                    }
                  }}
                >
                  <IoGitCompare
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--primary-color)",
                      margin: "55% auto",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {compareData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {compareData?.length}
                </span>
              )}
            </div>}
            <div className={classes.siderowrightmobile}>
              <Tooltip title={language === "eng" ? "Cart" : "Panier"}>
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => {
                      navigate(`/cart`);
                
                  }}
                >
                  <ShoppingCartOutlinedIcon
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--primary-color)",
                      margin: "55% auto",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {productData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {productData?.length}
                </span>
              )}
            </div>
            <div className={classes.siderowrightmobile}>
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  margin: "12px 5px",
                  borderRadius: "50%",
                }}
              >
                <Box sx={{ flexGrow: 0 }}>
                  <Tooltip title={language === "eng" ? "Profile" : "Mon Compte"}>
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      {userInfo?.id ? (
                        <Avatar
                          alt={userInfo.first_name}
                          src={`${process.env.REACT_APP_TESTING_API_IMAGE}/img/${userInfo.image}`}
                          style={{
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                          }}
                        />
                      ) : (
                        <PersonIcon
                          style={{
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            color: "var(--primary-color)",
                          }}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
              </div>
            </div>
          </div>
        </div>
        {/* {!isScrolled &&  */}
        <div style={{ width: "90%", margin: "0 auto" }}>
          <SearchBox />
        </div>
        {/* } */}
      </div>
      <div className={classes.navheight}></div>
    </>
  );
};

export default Navbar;
